// A list of all available font weights and their names
const FONT_WEIGHTS = {
  100: 'Thin',
  200: 'Extralight',
  300: 'Light',
  400: 'Regular',
  500: 'Medium',
  600: 'Semibold',
  700: 'Bold',
  800: 'Extrabold',
  900: 'Black'
};

// A list of all available font categories
const FONT_CATEGORIES = {
  serif: 'Serif',
  'sans-serif': 'Sans Serif',
  display: 'Display',
  handwriting: 'Handwriting',
  monospace: 'Monospace'
};

// Take a variant and return the font weight as a string
function convertVariantToFontWeight(variant) {
  if (variant === 'regular') return '400';
  if (variant === 'italic') return '400';
  return variant.replace(/[^0-9]/g, '');
}

// Take a list of font weights and convert them to an array of weights
// e.g. ['100', '300italic' ,'regular'] => [{ital: 0, wght: 100}, {ital: 1, wght: 300}, {ital: 0, wght: 400}]
function getGoogleFontWeights(fontWeights) {
  let includeItalic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return fontWeights
  // .map((w) => w)
  .filter(w => !includeItalic ? !w.includes('italic') : true).map(weight => {
    const wght = convertVariantToFontWeight(weight);
    return {
      ital: weight.includes('italic') ? 1 : 0,
      wght
    };
  });
}

// Take a list of google font weights and convert them to a formatted string
function getFontWeightString(fontWeights) {
  let includeItalic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const containsItalic = fontWeights.some(w => w.ital === 1);
  const formattedRegularWeights = fontWeights.reduce((accum, _ref) => {
    let {
      ital,
      wght
    } = _ref;
    if (ital === 0) accum.push(`${containsItalic && includeItalic ? `${ital},` : ''}${wght}`);
    return accum;
  }, []);
  const formattedItalicWeights = fontWeights.reduce((accum, _ref2) => {
    let {
      ital,
      wght
    } = _ref2;
    if (ital === 1 && includeItalic) accum.push(`${containsItalic && includeItalic ? `${ital},` : ''}${wght}`);
    return accum;
  }, []);
  return `${formattedItalicWeights.length ? 'ital,' : ''}wght@${formattedRegularWeights.join(';')}${formattedItalicWeights.length ? ';' : ''}${formattedItalicWeights.join(';')}`;
}

// https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;1,100;1,300;1,400&display=swap
/**
 * Take a font name and a list of weights and return a Google Fonts URL
 * @param {String} fontName
 * @param {Array} weights
 * @param {Boolean} includeItalic
 * @returns A google font URL
 */
function getGoogleFontUrl(fontName, weights) {
  let includeItalic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const formattedName = fontName.replace(/\s/g, '+');
  const fontWeights = getGoogleFontWeights(weights, includeItalic);
  const fontUrl = `https://fonts.googleapis.com/css2?family=${formattedName}:${getFontWeightString(fontWeights, includeItalic)}&display=swap`;
  return fontUrl;
}
export { FONT_CATEGORIES, FONT_WEIGHTS, convertVariantToFontWeight, getFontWeightString, getGoogleFontUrl, getGoogleFontWeights };